/**
 * Resume Button Component
 * Handles rendering of resume/play button with loading state
 */

import React from "react";
import { CSS_CLASSES, INLINE_STYLES } from "../utils/cardBodyConstants.js";

const PlayIcon = () => (
  <svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: "block" }}>
    <path d="M1 17V1L14 8.6L1 17Z" stroke="#96A8BA" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * Resume Button Component
 */
export const ResumeButton = ({
  resumeLoading,
  customeTime,
  onClick,
  showCondition = true,
  className = "",
}) => {
  if (!showCondition) {
    return null;
  }

  const isDisabled = resumeLoading || customeTime;
  const cursorStyle = isDisabled ? INLINE_STYLES.CURSOR_NOT_ALLOWED : INLINE_STYLES.CURSOR_POINTER;

  return (
    <div 
      className={`${CSS_CLASSES.PLAY_BUTTON} ${className}`} 
      onClick={isDisabled ? undefined : onClick}
    >
      <span style={{ ...cursorStyle, lineHeight: 0 }}>
        <PlayIcon />
      </span>
    </div>
  );
};
